(() => {
  const groups = () => document.querySelectorAll('[data-gx-size-sync="product"]');
  const picker = () => document.querySelector('main variant-picker[data-template-product-match="true"]');
  const sync = (value) => groups().forEach(group => {
    group.querySelectorAll('[data-gx-option]').forEach(input => {
      const checked = input.dataset.gxOption === value;
      if (input.checked !== checked) input.checked = checked;
    });
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) return;
    const group = input.closest('[data-gx-size-sync="product"]');
    if (group && input.dataset.gxOption) {
      const native = [...(picker()?.querySelectorAll('input[type="radio"]') || [])].find(el => el.value === input.dataset.gxOption);
      if (native && !native.checked) native.click();
      return;
    }
    if (input.closest('variant-picker') === picker()) sync(input.value);
  });
  const init = () => {
    const selected = picker()?.querySelector('input[type="radio"]:checked');
    if (selected) sync(selected.value);
  };
  init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
})();
